import styled from '@emotion/styled';

export const Container = styled.div`
  background-color: #e9ebf3;
  height: 100%;
  padding: 0.1rem 0;
`;
